import { render, staticRenderFns } from "./GradesIndex.vue?vue&type=template&id=327abbb8"
import script from "./GradesIndex.js?vue&type=script&lang=js&external"
export * from "./GradesIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports